<template>
  <div :class="alertClasses" role="alert">
    <div class="c-alert__content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  type: {
    type: String,
    default: 'info',
    validator: (value) => ['info', 'warning', 'danger', 'success', 'no-results'].includes(value)
  }
})

const alertClasses = computed(() => ({
  'c-alert': true,
  [`c-alert--${props.type}`]: true
}))
</script>

<style>
/* ISU Alert Component following Illinois State CSS methodology */
/* Base alert styles are handled by the Illinois State CSS framework */
</style>